import { Component, Input, Output, EventEmitter, OnInit, AfterViewInit } from '@angular/core';
import { Item } from '../../../models/gobig/item';

declare const $: any;

@Component({
  selector: 'app-table-items',
  templateUrl: './table-items.component.html',
  styleUrls: ['./table-items.component.css']
})
export class TableItemsComponent implements OnInit, AfterViewInit {



  @Input() data: any[] = [];
  @Input() bulk: number[] = [];
  public test: Array<number> = [];
  @Input() ticketStatus: string;
  @Input() status: boolean = false;
  @Input() askedLocation: any='';
  @Output() change: EventEmitter<any>;

  @Output() verComentarios: EventEmitter<any>;

  public saving = false;
  public ids: any[] = [];

  constructor() {
    this.change = new EventEmitter;
    this.verComentarios = new EventEmitter;
    this.test = this.bulk;
  }

  ngOnInit() {
    console.log(this.data);
    console.log(this.status);
  }

  checkAll() {
    let item;
    for (item of this.data) {
      if (!this.check(item.id)) {
        return false;
      }
    }
    return true;
  }

  check(id) {
    let i;
    for (i of this.bulk) {
      if (i === id) {
        return true;
      }
    }
    return false;
  }

  selectAll() {
    if (this.checkAll()){
      this.bulk = [];
    } else {
      this.bulk = [];
      let item;
      for (item of this.data) {
        if(item.internalLocation.id != this.askedLocation)
        this.bulk.push(item.id);
      }
    }
    this.change.emit(this.bulk);
  }

  selectItem(id, locationId) {

    if(locationId == this.askedLocation)
      return false;
    this.bulk = this.test;
    
    let i, find = false;
    for (i = 0; i < this.bulk.length; i ++) {
      if (this.bulk[i] === id) {
        this.bulk.splice(i , 1);
        find = true;
        break;
      }
    }

    if (!find && locationId != this.askedLocation) {
      this.bulk.push(id);
    }
    this.test = this.bulk;
    this.change.emit(this.bulk);
    
  }

  checkAllNew() {    
    
    let id;

    if(this.ids.length === 0){
      return false;
    }

    for (var i = 0; i < Number(this.ids['length']); i++) {
      
      const item = this.data.find((element) => element.id === Number(this.ids[i]));

      if (!this.check(item.id) && this.askedLocation !== item.internalLocation.id) {
        return false;
      }

    }
    return true;
  }


  selectAllNew() {
    let i: number;
    if (this.checkAllNew()){
      for (i = 0; i < this.ids.length; i++) {

        const item = this.data.find((element) => element.id === Number(this.ids[i]));

        if (this.check(Number(this.ids[i]))) {
          this.selectItem(Number(this.ids[i]), item.internalLocation.id);
        }

      }
    } else {     
      
      for (i = 0; i < this.ids.length; i++) {        

        const item = this.data.find((element) => element.id === Number(this.ids[i]));

        if (!this.check(Number(this.ids[i])) && this.askedLocation != item.internalLocation.id) {
          this.selectItem(Number(this.ids[i]), item.internalLocation.id);
        }
      }
    }
    this.change.emit(this.bulk);
  }

  ngAfterViewInit() {
    let table = $('#selectItems').DataTable({
      //'order': [[ 0, 'desc' ]],
      dom: 'Bflrtip',
      "columnDefs": [ {
        "targets": 0,
        "orderable": false
        } ],
      buttons: [
          /*{
            extend: 'copy',
            exportOptions: {
              columns: ':visible'
            }
          },*//*
          {
            extend: 'csv',
            exportOptions: {
              columns: ':visible'
            }
          },*/
          {
            extend: 'excel',
            text: '<i class="fa fa-file-excel-o"></i>',
            titleAttr: 'Excel',
            className: 'btn btn-sm btn-outline-success',
            exportOptions: {
              columns: ':visible'
            }
          },
          {
            extend: 'pdf',
            text: '<i class="fa fa-file-pdf-o"></i>',
            titleAttr: 'PDF',
            className: 'btn btn-sm btn-outline-danger',
            exportOptions: {
              columns: ':visible'
            }
          },
          {
            extend: 'print',
            text: '<i class="fa fa-print" aria-hidden="true"></i>',
            titleAttr: 'print',
            className: 'btn btn-sm btn-outline-primary',
            exportOptions: {
              columns: ':visible'
            }
          },
          {
            extend: 'colvis',
            text: '<i class="fa fa-columns" aria-hidden="true"></i>',
            className: 'btn btn-sm btn-outline-info',
            titleAttr: 'Column visibility'
          },
        ],
      'pagingType': 'full_numbers',
      'lengthMenu': [
        [5, 10, 25, 50, 100, 200, 500, 1000, -1],
        [5, 10, 25, 50, 100, 200, 500, 1000, 'All']
      ],
      responsive: true,
      language: {
        search: '_INPUT_',
        searchPlaceholder: 'Search records',
      }
    });

    table.on('click', '.select-all', (e) => {
      
      //var info = table.page.info();
      //var data = table.rows();
      //var rows = table.rows( {page:'current'} ).data();
      this.ids = table.column(1 , {page:'current'}).data();
      this.selectAllNew();

    });

    table.on( 'page.dt', () => {
      //var info = table.page.info();
      //console.log(info);
      this.ids = table.column(1 , {page:'current'}).data();
    });
  }

  openComments(item) {
    this.verComentarios.emit(item);
  }

}
